import { Box, FormControl, FormControlLabel, FormLabel, Radio, RadioGroup } from '@mui/material'
import { FormattedMessage, useIntl } from 'react-intl'
import { TradeAreasMode } from '../types'

function ModeRadio({ mode, onChange }) {
  const intl = useIntl()
  return (
    <FormControl size="small">
      <FormLabel id="trade-areas-mode">
        <FormattedMessage id="analysis.tradeAreas.mode" />
      </FormLabel>
      <RadioGroup
        value={mode || TradeAreasMode.Car}
        row
        aria-labelledby="trade-areas-mode"
        name="trade-areas-mode-radio-group"
        onChange={(e) => {
          onChange(e.target.value as TradeAreasMode)
        }}
      >
        <Box mb={2}>
          <FormControlLabel
            value={TradeAreasMode.Car}
            control={<Radio size="small" />}
            label={intl.formatMessage({ id: 'analysis.tradeAreas.car' })}
          />
          <FormControlLabel
            value={TradeAreasMode.Walk}
            control={<Radio size="small" />}
            label={intl.formatMessage({ id: 'analysis.tradeAreas.walk' })}
          />
        </Box>
      </RadioGroup>
    </FormControl>
  )
}

export default ModeRadio
